import { render, staticRenderFns } from "./HelpdeskAssigneePicker.vue?vue&type=template&id=20493308&scoped=true&"
import script from "./HelpdeskAssigneePicker.vue?vue&type=script&lang=ts&"
export * from "./HelpdeskAssigneePicker.vue?vue&type=script&lang=ts&"
import style0 from "./HelpdeskAssigneePicker.vue?vue&type=style&index=0&id=20493308&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20493308",
  null
  
)

export default component.exports